export class EmptyValidator {
    constructor(message) {
        this.message = message;
    }
    validate(field) {
        return field.trim() !== "";
    }
}
//# sourceMappingURL=EmptyValidator.js.map